import React from "react";
import { Navigate } from "react-router-dom";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import UserPanelFormLayer from "../../components/UserPanelFormLayer";
import { useAuth } from "../../context/AuthContext";

const CreateUserPanelPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Create User" />
      <UserPanelFormLayer mode="create" />
    </MasterLayout>
  );
};

export default CreateUserPanelPage;
